import React from "react"
import { Switch, Route } from "react-router-dom"
import { useRecoilState, useResetRecoilState } from "recoil"
import CssBaseline from "@material-ui/core/CssBaseline"
import Amplify from "aws-amplify"

import awsconfig from "./aws-exports"
import AuthenticatedRoute from "./components/AuthenticatedRoute"
import UnauthenticatedRoute from "./components/UnauthenticatedRoute"
import ViewLoadSpinner from "./components/ViewLoadSpinner"
import { fetchUser } from "./libs/manageAccounts"
import currentUser from "./store/currentUser"
import currentAssociation from "./store/currentAssociation"
import DashboardView from "./views/Dashboard"
import ErrorView from "./views/Error"
import LandingView from "./views/Landing"
import LogoutView from "./views/Logout"
import SignUpView from "./views/SignUp"
import SignInView from "./views/SignIn"

Amplify.configure(awsconfig)

export default function App() {
  const [isAuthenticating, setIsAuthenticating] = React.useState(true)
  const [user, setUser] = useRecoilState(currentUser)
  const resetUser = useResetRecoilState(currentUser)
  const resetAssociation = useResetRecoilState(currentAssociation)

  // Try to get the user info if logged in
  React.useEffect(() => {
    fetchUser(user)
      .then((currentUser) => {
        if (currentUser) {
          setUser(currentUser)
        } else {
          Amplify.Auth.signOut()
          resetUser()
          resetAssociation()
        }
      })
      .catch((error) => {
        console.log("error", error)
      })
      .finally(() => {
        setIsAuthenticating(false)
      })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div id="App" className="App">
      <CssBaseline />
      {!isAuthenticating ? (
        <Switch>
          <Route exact path="/">
            <LandingView />
          </Route>
          {/* <Route path="/documents/:token">
            <PublicDocumentShare />
          </Route> */}
          <AuthenticatedRoute path="/0">
            <DashboardView />
          </AuthenticatedRoute>
          <AuthenticatedRoute path="/logout">
            <LogoutView />
          </AuthenticatedRoute>
          <Route path="/signup">
            <SignUpView />
          </Route>
          <UnauthenticatedRoute path="/signin">
            <SignInView />
          </UnauthenticatedRoute>
          <Route path="*">
            <ErrorView />
          </Route>
        </Switch>
      ) : (
        <ViewLoadSpinner />
      )}
    </div>
  )
}
